/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getProfileCard.defs.js";
export { main as default } from "./getProfileCard.defs.js";
